export const adminCreateApiKey = `mutation adminCreateApiKey($input: ApiKeyCreateInput!) {
  adminCreateApiKey(input: $input) {
    keyId
    keySecret
    label
    description
    impersonatedUserId
    issuedAt
    expirationTime
    active
    applications {
      applicationId
      execute
      deploy
    }
  }
}`;

export const adminUpdateApiKey = `mutation adminUpdateApiKey($input: ApiKeyUpdateInput!) {
  adminUpdateApiKey(input: $input) {
    keyId
    label
    description
    issuedAt
    expirationTime
    impersonatedUserId
    active
    applications {
      applicationId
      execute
      deploy
    }
  }
}`;

export const adminDeleteApiKey = `mutation adminDeleteApiKey($keyId: ID!) {
  adminDeleteApiKey(keyId: $keyId) {
      keyId
  }
}`;
